import NavTab from './NavTab.vue';

NavTab.install = (Vue) => {
  Vue.component(NavTab.name, NavTab);
};

export default NavTab;
